export const SECONDS_PER_DAY = 86400

export const DEFAULT_RULE_ID = 'default'
